import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';
import * as actions from '@packages/packages-result/store/actions/packages-result.actions';
import { HotelResultPackagesResponse } from '@packages/packages-result/entities/hotel-results';

export interface HotelResultsState extends EntityState<HotelSearched> { }

function getId(hotelOption: HotelSearched): number {
  return hotelOption.OptionId;
}

export const hotelResultsAdapter: EntityAdapter<HotelSearched> = createEntityAdapter<HotelSearched>({
  selectId: getId
});

export const initialState: HotelResultsState = hotelResultsAdapter.getInitialState({});

export const reducer = createReducer(
  initialState,
  on(
    actions.searchPackageAction,
    actions.searchPackageHotelsAction,
    actions.clearPackageResultsAction,
    () => initialState
  ),
  on(actions.searchPackageHotelsSuccessAction, (state, { response }) => hotelResultsAdapter.setAll(
    hotelResultsByPackages(response), state)
  ),
  on(
    actions.searchPackageHotelsWithPaginationSuccessAction,
    (state, { response }) => hotelResultsAdapter.addMany(hotelResultsByPackages(response), state)
  ),
  on(actions.searchPackageHotelsErrorAction, (state) => hotelResultsAdapter.removeAll(state)),
  on(
    actions.searchPackageHotelsWithFiltersSuccessAction,
    (state, { response }) => hotelResultsAdapter.setAll(hotelResultsByPackages(response), state)
  ),
);

export function hotelResultsReducer(state: HotelResultsState, action: Action): HotelResultsState {
  return reducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = hotelResultsAdapter.getSelectors();

function hotelResultsByPackages(response: HotelResultPackagesResponse): HotelSearched[] {
  return response?.HotelResults?.map(hotel => {
    const depatureFlights = response?.AirResultSelected?.Sectors?.[0]?.Flights || [];
    const airportCityCode = depatureFlights?.[depatureFlights?.length - 1]?.ArrivalAirport;
    const parts = hotel?.DistanceFromAirport?.split(/(\d+)/)?.filter(part => !!part);
    const distanceFromAirport = parts?.length ? `${parts[0]} ${parts[1]}` : undefined;
    return {
      ...hotel,
      DistanceFromAirport: distanceFromAirport,
      AirportCityCode: airportCityCode
    };
  }) || [];
}

export const exportedForTesting = {
  getId,
};
